import { SearchInput } from '@/components/ui/SearchInput';
import { cn } from '@/lib/utils';

import { HEADER_CONTROL } from './page.parts';

export const HeaderSearch = (
  props: Omit<React.ComponentProps<typeof SearchInput>, 'className'>
) => (
  <SearchInput
    {...props}
    className={cn(HEADER_CONTROL, 'w-60 flex-none py-0')}
  />
);
